<ng-container *ngIf="mode === 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <entity-item [entity]="$safeNavigationMigration(control?.value)"></entity-item>

</ng-template>
<ng-template #edit>

    <ng-select [searchFn]="searchFn" [items]="data$ | async" bindLabel="name" bindValue="_id" [placeholder]="placeholder" [searchable]="true" [formControl]="control" [multiple]="multiple">
    </ng-select>

</ng-template>


<ng-template #emptyField>
    <span class="empty-field">{{ emptyText }}</span>
</ng-template>